import React, { useMemo } from 'react';

import { useLoggedInUser, useFeatureFlags } from '@tcc/shared-data-lib';
import { importFromS3 } from '../../utils/importFromS3';
import { useUserLoggedInConfigs, useFeatureFlagsConfigs } from '../../utils/sharedData';
import { Operation } from '../../hooks/useOperations/types';
import { useImpersonatedOperation } from '../../hooks/useImpersonatedOperation';

interface FixitToolPluginContainerProps {
  operationsSelected: Operation[]
}

const S3Plugin = React.lazy(() => importFromS3('fixit-tool'));

export const FixitToolPluginContainer: React.FC<FixitToolPluginContainerProps> = ({ operationsSelected }: FixitToolPluginContainerProps) => {
  const { user } = useLoggedInUser(useUserLoggedInConfigs);
  const { featureFlags } = useFeatureFlags(useFeatureFlagsConfigs(user));
  const useModuleFederation = featureFlags?.['web.fixitTool.module-federation'];

  const FixitToolPlugin = useMemo(() => {
    if (useModuleFederation) {
      return React.lazy(() => import('fixitTool/FixitTool'));
    }
    return S3Plugin;
  }, [useModuleFederation]);

  const { isLoading, operation } = useImpersonatedOperation();
  const operationSelected = operation || operationsSelected[0];

  // prevent rendering Fixit Tool if we're fetching operations
  if (isLoading || !operationSelected?.operationOwnerId) return null;

  return (
    <FixitToolPlugin
      operationSelected={operationSelected}
    />
  );
};
